import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/developer/LoginPage.vue'
import Home from '../views/Home.vue'
import Welcome from '../views/Welcome.vue'
import DataScreen from '../views/DataScreen.vue'
import SoftManager from '../views/SoftManager.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    component: Login,
    meta: {
      title: '登录 - 7c云 ∙ 开发端'
    }
  },
  {
    path: '/register',
    component: () => import('../views/developer/RegisterPage.vue'),
    meta: {
      title: '注册 - 7c云 ∙ 开发端'
    }
  },
  {
    path: '/forget',
    component: () => import('../views/developer/ForgetPage.vue'),
    meta: {
      title: '忘记密码 - 7c云 ∙ 开发端'
    }
  },
  {
    path: '/result',
    component: () => import('../views/AccountResult.vue')
  },

  {
    path: '/forget/result',
    component: () => import('../views/AccountForget.vue')
  },
  {
    path: '/change',
    component: () => import('../views/developer/ChangePage.vue'),
    meta: {
      title: '更改密码 - 7c云 ∙ 开发端'
    }
  },
  {
    path: '/active',
    component: () => import('../views/developer/ActiveResult.vue'),
    meta: {
      title: '激活账号 - 7c云 ∙ 开发端'
    }
  },

  {
    path: '/home',
    component: Home,
    redirect: '/welcome',
    children: [
      { path: '/welcome', component: Welcome, meta: { title: '欢迎 - 7c云 ∙ 开发端' } },

      { path: '/datascreen', component: DataScreen, meta: { title: '数据大屏 - 7c云 ∙ 开发端' } },

      { path: '/softmanager', component: SoftManager, meta: { title: '软件管理 - 7c云 ∙ 开发端' } },

      { path: '/cardmanager', component: () => import('../views/CardManager.vue'), meta: { title: '卡密管理 - 7c云 ∙ 开发端' } },

      { path: '/userlist', component: () => import('../views/userItem/UserList.vue'), meta: { title: '用户列表 - 7c云 ∙ 开发端' } },
      { path: '/userlog', component: () => import('../views/userItem/UserLog.vue'), meta: { title: '用卡记录 - 7c云 ∙ 开发端' } },

      { path: '/longvar', component: () => import('../views/remoteItem/RemoteVar.vue'), meta: { title: '远程变量 - 7c云 ∙ 开发端' } },
      { path: '/longdatas', component: () => import('../views/remoteItem/RemoteData.vue'), meta: { title: '远程数据 - 7c云 ∙ 开发端' } },
      { path: '/longfn', component: () => import('../views/remoteItem/RemoteFn.vue'), meta: { title: '远程函数 - 7c云 ∙ 开发端' } },

      { path: '/agentlist', component: () => import('../views/agentItem/AgentList.vue'), meta: { title: '代理人列表 - 7c云 ∙ 开发端' } },
      { path: '/agentlog', component: () => import('../views/agentItem/AgentLog.vue'), meta: { title: '卡密记录 - 7c云 ∙ 开发端' } },
      { path: '/integrallog', component: () => import('../views/agentItem/IntegralLog.vue'), meta: { title: '积分记录 - 7c云 ∙ 开发端' } },

      { path: '/log', component: () => import('../views/OperationLog.vue'), meta: { title: '操作日志 - 7c云 ∙ 开发端' } },

      { path: '/invitee', component: () => import('../views/Invitee.vue'), meta: { title: '推广邀请 - 7c云 ∙ 开发端' } },
      { path: '/hotupdate', component: () => import('../views/HotUpdate.vue'), meta: { title: '热更新 - 7c云 ∙ 开发端' } },
      { path: '/jz', component: () => import('../views/JZ.vue'), meta: { title: '深造学院 - 7c云 ∙ 开发端' } },
      { path: '/recharge', component: () => import('../views/Recharge.vue'), meta: { title: '充值 - 7c云 ∙ 开发端' } },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  /**
   * to 将要访问的路径
   * from 从那个路径跳转来
  */
  if (to.meta.title) {
    //   let mytitle = window.sessionStorage.getItem('role')
    //   if(mytitle == 'developer'){
    //     mytitle = "开发端"
    //   }else if(mytitle == 'agent'){
    //     mytitle = "代理端"
    //   }
    document.title = to.meta.title
  }
  console.log("to.path==", to.path);
  if (to.path === "/" || to.path === "/login" || to.path === '/active' || to.path === '/forget/result' || to.path === '/result' || to.path === '/register' || to.path === '/forget' || to.path.indexOf('/change') > -1) {
    return next()
  }

  const tokenStr = window.sessionStorage.getItem('token')
  // console.log("tokenStr:",tokenStr);
  if (!tokenStr) {
    console.log('跳到登录--', to.path);
    return next('/login')
  }else{
    // console.log("有token:-----不跳转");
  }
  next()
})
//挂载导航守卫

export default router
